import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon } from 'lucide-react';
export const Comparison = () => {
  const rows = [{
    sin: 'Preparás material desde cero para cada alumno nuevo',
    con: 'Diagnóstico, plan y checklist listos en la primera clase'
  }, {
    sin: 'Sin plan para el alumno de ciudadanía urgente',
    con: 'Plan intensivo de 4 semanas listo para usar mañana'
  }, {
    sin: 'No conocés los criterios reales del CILS ni del CELI',
    con: 'Rúbricas del examinador y simulacros por nivel incluidos'
  }, {
    sin: 'El alumno abandona y no sabés por qué',
    con: 'Semáforo de retención y protocolo de intervención a tiempo'
  }, {
    sin: 'Cobrás por hora y llegaste al techo de ingresos',
    con: 'Calculadora de tarifa real + programas cerrados + producto digital'
  }, {
    sin: 'Sin material adaptado al contexto argentino',
    con: 'Todo en español rioplatense con casos reales de CABA, Rosario y Córdoba'
  }, {
    sin: 'El itañol del alumno te consume la clase entera',
    con: 'Tabla de 20 errores y protocolo de corrección sin interrumpir el flujo'
  }, {
    sin: 'Ingresos inestables que dependen de no cancelar',
    con: 'Sistema de renovación y producto digital que vende mientras dormís'
  }];
  return <section className="py-10 md:py-20 px-4 md:px-5" data-id="element-50">
      <div className="max-w-[860px] mx-auto" data-id="element-51">
        <div className="text-center mb-8 md:mb-10" data-id="element-52">
          <p className="text-xs tracking-[0.1em] uppercase text-cyan mb-3 font-semibold" data-id="element-53">
            La realidad
          </p>
          <h2 className="text-[clamp(24px,4vw,36px)] font-extrabold leading-[1.2]" data-id="element-54">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        {/* MOBILE: Stacked compact cards */}
        <div className="md:hidden space-y-2.5" data-id="element-55">
          {/* Mobile section legend */}
          <div className="grid grid-cols-2 gap-2 mb-3" data-id="element-56">
            <div className="flex items-center justify-center gap-1.5 py-2 rounded-lg bg-rojo/5 border border-rojo/20" data-id="element-57">
              <XIcon size={14} className="text-rojo" data-id="element-58" />
              <span className="text-[11px] font-bold text-rojo uppercase tracking-wider" data-id="element-59">
                Sin el sistema
              </span>
            </div>
            <div className="flex items-center justify-center gap-1.5 py-2 rounded-lg bg-verde/5 border border-verde/20" data-id="element-60">
              <CheckIcon size={14} className="text-verde stroke-[3]" data-id="element-61" />
              <span className="text-[11px] font-bold text-verde uppercase tracking-wider" data-id="element-62">
                Con KIT PRO
              </span>
            </div>
          </div>

          {rows.map((row, i) => <div key={i} className="bg-gris-oscuro border border-gris-medio rounded-xl overflow-hidden" data-id="element-63">
              {/* Sin */}
              <div className="flex gap-2.5 p-3 bg-rojo/[0.04]" data-id="element-64">
                <div className="shrink-0 w-5 h-5 rounded-full bg-rojo/15 border border-rojo/30 flex items-center justify-center mt-0.5" data-id="element-65">
                  <XIcon size={11} className="text-rojo stroke-[3]" data-id="element-66" />
                </div>
                <p className="text-[12.5px] text-[#ddd] leading-snug flex-1" data-id="element-67">
                  {row.sin}
                </p>
              </div>

              {/* Divider with arrow */}
              <div className="relative flex items-center justify-center -my-px" data-id="element-68">
                <div className="absolute inset-x-3 h-px bg-gris-medio" data-id="element-69"></div>
                <div className="relative bg-gris-oscuro px-2 py-0.5 rounded-full border border-gris-medio" data-id="element-70">
                  <ArrowDownIcon size={11} className="text-cyan" data-id="element-71" />
                </div>
              </div>

              {/* Con */}
              <div className="flex gap-2.5 p-3 bg-verde/[0.04]" data-id="element-72">
                <div className="shrink-0 w-5 h-5 rounded-full bg-verde/15 border border-verde/30 flex items-center justify-center mt-0.5" data-id="element-73">
                  <CheckIcon size={11} className="text-verde stroke-[3]" data-id="element-74" />
                </div>
                <p className="text-[12.5px] text-[#ddd] leading-snug flex-1 font-medium" data-id="element-75">
                  {row.con}
                </p>
              </div>
            </div>)}
        </div>

        {/* DESKTOP: Table layout */}
        <div className="hidden md:block" data-id="element-76">
          <table className="w-full border-collapse text-[14px]" data-id="element-77">
            <thead data-id="element-78">
              <tr data-id="element-79">
                <th className="p-4 text-left text-[13px] font-bold text-gris-claro tracking-wider uppercase border-b border-[#222] w-1/2" data-id="element-80">
                  Sin el sistema
                </th>
                <th className="p-4 text-left text-[13px] font-bold text-gris-claro tracking-wider uppercase border-b border-[#222] w-1/2" data-id="element-81">
                  Con el KIT ITALIANO PRO™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-82">
              {rows.map((row, i) => <tr key={i} data-id="element-83">
                  <td className="p-4 border-b border-[#1a1a1a] text-rojo align-top" data-id="element-84">
                    <div className="flex gap-2" data-id="element-85">
                      <XIcon size={16} className="shrink-0 mt-0.5" data-id="element-86" />
                      <span data-id="element-87">{row.sin}</span>
                    </div>
                  </td>
                  <td className="p-4 border-b border-[#1a1a1a] text-verde align-top" data-id="element-88">
                    <div className="flex gap-2" data-id="element-89">
                      <CheckIcon size={16} className="shrink-0 mt-0.5 stroke-[3]" data-id="element-90" />
                      <span data-id="element-91">{row.con}</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
};